import api from '..'

export async function deletePartner(id: string): Promise<void> {
  await api.delete(`/partners/${id}`)
}
